import React from 'react';
import { getSearcherForm } from './registry';
import type { SearcherFormProps } from './types';

interface SearcherFormRendererProps extends SearcherFormProps {
  searcherId: string;
}

/**
 * Renders the real form for `searcherId`, or nothing when that searcher has no
 * form (url-only tabs such as autos are rendered as links by the hero instead).
 */
export const SearcherForm: React.FC<SearcherFormRendererProps> = ({ searcherId, ...formProps }) => {
  const Form = getSearcherForm(searcherId);

  if (!Form) return null;

  return <Form {...formProps} />;
};

export default SearcherForm;
